// excelUtils.js
import * as XLSX from "xlsx";

/**
 * Reads an Excel file and returns [headers, rows]
 * @param {File} file
 * @returns {Promise<{ headers: string[], rows: any[][] }>}
 */
export const parseExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const arrayBuffer = evt.target.result;
        const workbook = XLSX.read(arrayBuffer, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = jsonData[0] || [];
        const rows = jsonData.slice(1);

        resolve({ headers, rows });
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = (err) => reject(err);

    reader.readAsArrayBuffer(file);
  });
};
